import React from "react";
import Typewriter from "typewriter-effect";
import { useLanguage } from "../../context/LanguageContext";

function Type() {
  const { t } = useLanguage();
  return (
    <Typewriter
      key={t.home.typeStrings.join(",")}
      options={{
        strings: t.home.typeStrings,
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
